// notices stream: carrier notices, the accountability loop, and policy history.
export const en: Record<string, string> = {
  "nav.notices": "Notices",
  "notices.title": "Carrier notices",
  "notices.subtitle": "Everything a carrier told us about a policy, who owns it, what was done, how it ended.",
  "notices.filter.open": "Open",
  "notices.filter.mine": "Mine",
  "notices.filter.resolved": "Closed",
  "notices.filter.all": "All",
  "notices.none": "No notices in this view.",
  "notices.noneHint": "Hand Faraday a carrier report, an email or a photo of a notice and it records every row here, assigned and with a clock.",
  "notices.add": "Add a notice",
  "notices.carrier": "Carrier",
  "notices.kind": "Kind",
  "notices.policyNumber": "Policy #",
  "notices.customerName": "Name on notice",
  "notices.effectiveAt": "Effective",
  "notices.amount": "Amount",
  "notices.details": "Details",
  "notices.received": "Received",
  "notices.assignee": "Owner",
  "notices.unassigned": "Unassigned",
  "notices.unmatched": "Unmatched",
  "notices.sla": "First touch",
  "notices.slaLeft": "{h}h left",
  "notices.slaOverdue": "{h}h overdue",
  "notices.touched": "Touched",
  "notices.touches": "{n} attempts",
  "notices.logTouch": "Log a contact",
  "notices.channel.call": "Call",
  "notices.channel.text": "Text",
  "notices.channel.email": "Email",
  "notices.channel.visit": "In person",
  "notices.channel.note": "Note",
  "notices.reached": "Reached the customer",
  "notices.touchNote": "What happened",
  "notices.close": "Close notice",
  "notices.outcome": "Outcome",
  "notices.outcome.saved": "Saved",
  "notices.outcome.paid": "Paid",
  "notices.outcome.reinstated": "Reinstated",
  "notices.outcome.rewritten": "Rewritten",
  "notices.outcome.lost": "Lost",
  "notices.outcome.not_needed": "Not needed",
  "notices.outcome.other": "Other",
  "notices.assign": "Assign",
  "notices.recorded": "Notice recorded",
  "notices.duplicate": "That notice was already open",
  "notices.touchSaved": "Contact logged",
  "notices.closed": "Notice closed",
  "notices.assigned": "Notice assigned",
  "notices.kind.cancellation_pending": "Cancellation pending",
  "notices.kind.cancelled": "Cancelled",
  "notices.kind.nonpay": "Non-payment",
  "notices.kind.reinstated": "Reinstated",
  "notices.kind.renewal_offer": "Renewal offer",
  "notices.kind.premium_increase": "Premium increase",
  "notices.kind.nonrenewal": "Non-renewal",
  "notices.kind.underwriting_inquiry": "Underwriting inquiry",
  "notices.kind.missing_document": "Missing document",
  "notices.kind.payment_due": "Payment due",
  "notices.kind.claim_update": "Claim update",
  "notices.kind.other": "Other",
  "notices.status.new": "New",
  "notices.status.assigned": "Assigned",
  "notices.status.contacted": "Contacted",
  "notices.status.resolved": "Closed",
  "notices.status.lost": "Lost",
  "notices.source.manual": "entered by hand",
  "notices.source.upload": "from a report",
  "notices.source.photo": "from a photo",
  "notices.source.email": "from email",
  "notices.source.ivans": "from the carrier feed",
  "notices.source.import": "from an import",
  "notices.source.faraday": "via Faraday",
  "notices.history": "Policy history",
  "notices.history.none": "No changes recorded yet.",
  "notices.today": "Carrier notices",
  "notices.customerCard": "Carrier notices",
  "notices.daysToEffective": "{d} days",
  "notices.effectivePast": "Past",
  "reports.accountability": "Accountability",
  "today.kind.notice_overdue": "notice past SLA",
};

export const es: Record<string, string> = {
  "nav.notices": "Avisos",
  "notices.title": "Avisos de aseguradoras",
  "notices.subtitle": "Todo lo que una aseguradora nos dijo de una póliza, quién lo atiende, qué se hizo y cómo terminó.",
  "notices.filter.open": "Abiertos",
  "notices.filter.mine": "Míos",
  "notices.filter.resolved": "Cerrados",
  "notices.filter.all": "Todos",
  "notices.none": "No hay avisos en esta vista.",
  "notices.noneHint": "Pásale a Faraday un reporte, un correo o la foto de un aviso y registra cada renglón aquí, asignado y con reloj.",
  "notices.add": "Agregar aviso",
  "notices.carrier": "Aseguradora",
  "notices.kind": "Tipo",
  "notices.policyNumber": "Póliza #",
  "notices.customerName": "Nombre en el aviso",
  "notices.effectiveAt": "Efectivo",
  "notices.amount": "Monto",
  "notices.details": "Detalles",
  "notices.received": "Recibido",
  "notices.assignee": "Responsable",
  "notices.unassigned": "Sin asignar",
  "notices.unmatched": "Sin cliente",
  "notices.sla": "Primer contacto",
  "notices.slaLeft": "quedan {h}h",
  "notices.slaOverdue": "{h}h vencido",
  "notices.touched": "Atendido",
  "notices.touches": "{n} intentos",
  "notices.logTouch": "Registrar contacto",
  "notices.channel.call": "Llamada",
  "notices.channel.text": "Mensaje",
  "notices.channel.email": "Correo",
  "notices.channel.visit": "En persona",
  "notices.channel.note": "Nota",
  "notices.reached": "Se logró contactar",
  "notices.touchNote": "Qué pasó",
  "notices.close": "Cerrar aviso",
  "notices.outcome": "Resultado",
  "notices.outcome.saved": "Salvada",
  "notices.outcome.paid": "Pagada",
  "notices.outcome.reinstated": "Reinstalada",
  "notices.outcome.rewritten": "Reescrita",
  "notices.outcome.lost": "Perdida",
  "notices.outcome.not_needed": "No aplicaba",
  "notices.outcome.other": "Otro",
  "notices.assign": "Asignar",
  "notices.recorded": "Aviso registrado",
  "notices.duplicate": "Ese aviso ya estaba abierto",
  "notices.touchSaved": "Contacto registrado",
  "notices.closed": "Aviso cerrado",
  "notices.assigned": "Aviso asignado",
  "notices.kind.cancellation_pending": "Cancelación pendiente",
  "notices.kind.cancelled": "Cancelada",
  "notices.kind.nonpay": "Falta de pago",
  "notices.kind.reinstated": "Reinstalada",
  "notices.kind.renewal_offer": "Oferta de renovación",
  "notices.kind.premium_increase": "Aumento de prima",
  "notices.kind.nonrenewal": "No renovación",
  "notices.kind.underwriting_inquiry": "Consulta de suscripción",
  "notices.kind.missing_document": "Documento faltante",
  "notices.kind.payment_due": "Pago por vencer",
  "notices.kind.claim_update": "Actualización de reclamo",
  "notices.kind.other": "Otro",
  "notices.status.new": "Nuevo",
  "notices.status.assigned": "Asignado",
  "notices.status.contacted": "Contactado",
  "notices.status.resolved": "Cerrado",
  "notices.status.lost": "Perdido",
  "notices.source.manual": "capturado a mano",
  "notices.source.upload": "de un reporte",
  "notices.source.photo": "de una foto",
  "notices.source.email": "de un correo",
  "notices.source.ivans": "del feed de la aseguradora",
  "notices.source.import": "de una importación",
  "notices.source.faraday": "vía Faraday",
  "notices.history": "Historial de la póliza",
  "notices.history.none": "Sin cambios registrados.",
  "notices.today": "Avisos de aseguradoras",
  "notices.customerCard": "Avisos de aseguradoras",
  "notices.daysToEffective": "{d} días",
  "notices.effectivePast": "Pasado",
  "reports.accountability": "Responsabilidad",
  "today.kind.notice_overdue": "aviso fuera de plazo",
};
